var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.25 0.625H1.75C1.35232 0.625455 0.971048 0.783636 0.689842 1.06484C0.408636 1.34605 0.250455 1.72731 0.25 2.125V18.625C0.250007 18.7589 0.285848 18.8903 0.353802 19.0057C0.421756 19.121 0.519347 19.2161 0.636442 19.281C0.753538 19.3459 0.88587 19.3783 1.0197 19.3747C1.15354 19.3712 1.28399 19.332 1.39752 19.261L6.99936 15.7594L12.6025 19.261C12.7161 19.332 12.8465 19.3712 12.9803 19.3747C13.1142 19.3783 13.2465 19.3459 13.3636 19.281C13.4807 19.2161 13.5783 19.121 13.6462 19.0057C13.7142 18.8903 13.75 18.7589 13.75 18.625V2.125C13.7495 1.72731 13.5914 1.34605 13.3102 1.06484C13.029 0.783636 12.6477 0.625455 12.25 0.625Z"
});

function SvgBookmarkFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkFilled);
export default __webpack_public_path__ + "static/media/bookmark_filled.9acfa27c3ce6da28e807d0b7ce539ec6.svg";
export { ForwardRef as ReactComponent };